export  default {
  "code"
:
  0, "data"
:
  [{
    "id": "2",
    "harborNameCn": "中山外运港",
    "harborNameEn": "Zhongshan Sinotrans ",
    "harborLongitude": 113.4869,
    "harborLatitude": 22.5712,
  }, {
    "id": "3",
    "harborNameCn": "容奇港",
    "harborNameEn": "RONGQI ",
    "harborLongitude": 113.2829,
    "harborLatitude": 22.8029,
  }, {
    "id": "4",
    "harborNameCn": "勒流港",
    "harborNameEn": "LELIU ",
    "harborLongitude": 113.1324,
    "harborLatitude": 22.8521,
  }, {
    "id": "5",
    "harborNameCn": "蓬莱市港",
    "harborNameEn": "PENGLAI ",
    "harborLongitude": 120.8036,
    "harborLatitude": 37.822325,
  }, {
    "id": "6",
    "harborNameCn": "南沙港",
    "harborNameEn": "NANSHA ",
    "harborLongitude": 113.66055,
    "harborLatitude": 22.669175,
  }, {
    "id": "7",
    "harborNameCn": "龙口港",
    "harborNameEn": "LONGKOU ",
    "harborLongitude": 120.316666666667,
    "harborLatitude": 37.65,
  }, {
    "id": "8",
    "harborNameCn": "莱州港",
    "harborNameEn": "LAIZHOU ",
    "harborLongitude": 119.94575,
    "harborLatitude": 37.41619,
  }, {
    "id": "9",
    "harborNameCn": "洋山港",
    "harborNameEn": "YANGSHAN ",
    "harborLongitude": 122.0694,
    "harborLatitude": 30.6137,
  }, {
    "id": "10",
    "harborNameCn": "黄骅港",
    "harborNameEn": "HUANGHUA ",
    "harborLongitude": 118.11425,
    "harborLatitude": 38.325,
  }, {
    "id": "11",
    "harborNameCn": "顺德港",
    "harborNameEn": "SHUNDE ",
    "harborLongitude": 113.283249,
    "harborLatitude": 22.8030853,
  }, {
    "id": "12",
    "harborNameCn": "大铲湾港",
    "harborNameEn": "DACHAN BAY ",
    "harborLongitude": 113.8702,
    "harborLatitude": 22.538085,
  }, {
    "id": "13",
    "harborNameCn": "蛇口港",
    "harborNameEn": "SHEKOU ",
    "harborLongitude": 113.9246,
    "harborLatitude": 22.4929,
  }, {
    "id": "14",
    "harborNameCn": "盐田港",
    "harborNameEn": "YANTIAN ",
    "harborLongitude": 114.2765,
    "harborLatitude": 22.575,
  }, {
    "id": "15",
    "harborNameCn": "赤湾港",
    "harborNameEn": "CHIWAN ",
    "harborLongitude": 113.88175,
    "harborLatitude": 22.462935,
  }, {
    "id": "16",
    "harborNameCn": "新沙港",
    "harborNameEn": "XINSHA ",
    "harborLongitude": 113.5575,
    "harborLatitude": 22.97707,
  }, {
    "id": "17",
    "harborNameCn": "花都港",
    "harborNameEn": "HUADU ",
    "harborLongitude": 113.1335,
    "harborLatitude": 23.3472,
  }, {
    "id": "18",
    "harborNameCn": "乌冲港",
    "harborNameEn": "WUCHONG ",
    "harborLongitude": 113.4554,
    "harborLatitude": 23.0939,
  }, {
    "id": "19",
    "harborNameCn": "三山港",
    "harborNameEn": "Sanshan ",
    "harborLongitude": 113.2287,
    "harborLatitude": 23.0379,
  }, {
    "id": "20",
    "harborNameCn": "佛山市港",
    "harborNameEn": "Foshan ",
    "harborLongitude": 113.0719335,
    "harborLatitude": 22.99695585,
  }, {
    "id": "21",
    "harborNameCn": "义乌港",
    "harborNameEn": "Yiwu ",
    "harborLongitude": 120.0751,
    "harborLatitude": 29.3032,
  }, {
    "id": "22",
    "harborNameCn": "鹤山港",
    "harborNameEn": "HESHAN ",
    "harborLongitude": 113.0023,
    "harborLatitude": 22.8014,
  }, {
    "id": "23",
    "harborNameCn": "台山港",
    "harborNameEn": "Taishan ",
    "harborLongitude": 112.79435,
    "harborLatitude": 22.25272,
  }, {
    "id": "24",
    "harborNameCn": "无锡港",
    "harborNameEn": "Wuxi ",
    "harborLongitude": 120.287777777778,
    "harborLatitude": 31.5738888888889,
  }, {
    "id": "25",
    "harborNameCn": "常州港",
    "harborNameEn": "CHANGZHOU ",
    "harborLongitude": 119.995937,
    "harborLatitude": 31.9738598,
  }, {
    "id": "26",
    "harborNameCn": "潮州港",
    "harborNameEn": "CHAOZHOU ",
    "harborLongitude": 117.104473,
    "harborLatitude": 23.56575395,
  }, {
    "id": "27",
    "harborNameCn": "深圳港",
    "harborNameEn": "shenzhen ",
    "harborLongitude": 113.8535,
    "harborLatitude": 22.5045,
  }, {
    "id": "28",
    "harborNameCn": "上海港",
    "harborNameEn": "SHANGHAI ",
    "harborLongitude": 121.61475,
    "harborLatitude": 31.366365,
  }, {
    "id": "29",
    "harborNameCn": "丹东港",
    "harborNameEn": "DANDONG ",
    "harborLongitude": 124.23545,
    "harborLatitude": 39.90644,
  }, {
    "id": "31",
    "harborNameCn": "东莞港",
    "harborNameEn": "DONGGUAN ",
    "harborLongitude": 113.6116,
    "harborLatitude": 22.92799,
  }, {
    "id": "32",
    "harborNameCn": "东营港",
    "harborNameEn": "DONGYING ",
    "harborLongitude": 118.97715,
    "harborLatitude": 38.08194,
  }, {
    "id": "33",
    "harborNameCn": "防城港",
    "harborNameEn": "FANGCHENGGANG ",
    "harborLongitude": 108.384,
    "harborLatitude": 21.59459,
  }, {
    "id": "34",
    "harborNameCn": "宁波港",
    "harborNameEn": "NINGBO ",
    "harborLongitude": 121.8525,
    "harborLatitude": 29.926545,
  }, {
    "id": "35",
    "harborNameCn": "青岛港",
    "harborNameEn": "QINGDAO ",
    "harborLongitude": 120.3201,
    "harborLatitude": 36.05661,
  }, {
    "id": "36",
    "harborNameCn": "海口港",
    "harborNameEn": "Haikou ",
    "harborLongitude": 110.27885,
    "harborLatitude": 20.052635,
  }, {
    "id": "37",
    "harborNameCn": "厦门港",
    "harborNameEn": "XIAMEN ",
    "harborLongitude": 118.02925,
    "harborLatitude": 24.503175,
  }, {
    "id": "38",
    "harborNameCn": "惠州港",
    "harborNameEn": "HUIZHOU ",
    "harborLongitude": 114.62845,
    "harborLatitude": 22.673815,
  }, {
    "id": "39",
    "harborNameCn": "葫芦岛港",
    "harborNameEn": "HULUDAO ",
    "harborLongitude": 121.0103,
    "harborLatitude": 40.71915,
  }, {
    "id": "40",
    "harborNameCn": "江门港",
    "harborNameEn": "JIANGMEN ",
    "harborLongitude": 113.1198,
    "harborLatitude": 22.604095,
  }, {
    "id": "41",
    "harborNameCn": "江阴港",
    "harborNameEn": "JIANGYIN ",
    "harborLongitude": 120.1911,
    "harborLatitude": 31.917035,
  }, {
    "id": "42",
    "harborNameCn": "嘉兴港",
    "harborNameEn": "JIAXING ",
    "harborLongitude": 121.09545,
    "harborLatitude": 30.609,
  }, {
    "id": "43",
    "harborNameCn": "锦州港",
    "harborNameEn": "JINZHOU ",
    "harborLongitude": 121.04575,
    "harborLatitude": 40.83311,
  }, {
    "id": "44",
    "harborNameCn": "天津港",
    "harborNameEn": "TIANJIN ",
    "harborLongitude": 117.73725,
    "harborLatitude": 38.96904,
  }, {
    "id": "45",
    "harborNameCn": "茂名港",
    "harborNameEn": "MAOMING ",
    "harborLongitude": 111.0855,
    "harborLatitude": 21.449,
  }, {
    "id": "46",
    "harborNameCn": "南通港",
    "harborNameEn": "NANTONG ",
    "harborLongitude": 120.865,
    "harborLatitude": 31.973045,
  }, {
    "id": "47",
    "harborNameCn": "福州港",
    "harborNameEn": "FUZHOU ",
    "harborLongitude": 119.43515,
    "harborLatitude": 26.000305,
  }, {
    "id": "48",
    "harborNameCn": "宁德港",
    "harborNameEn": "NINGDE ",
    "harborLongitude": 119.70695,
    "harborLatitude": 26.76358,
  }, {
    "id": "49",
    "harborNameCn": "沈阳港",
    "harborNameEn": "SHENYANG ",
    "harborLongitude": 123.75,
    "harborLatitude": 41.83768,
  }, {
    "id": "50",
    "harborNameCn": "泉州港",
    "harborNameEn": "QUANZHOU ",
    "harborLongitude": 118.7325,
    "harborLatitude": 24.8285,
  }, {
    "id": "51",
    "harborNameCn": "日照港",
    "harborNameEn": "RIZHAO ",
    "harborLongitude": 119.5269,
    "harborLatitude": 35.361815,
  }, {
    "id": "52",
    "harborNameCn": "汕头港",
    "harborNameEn": "SHANTOU ",
    "harborLongitude": 116.672,
    "harborLatitude": 23.341,
  }, {
    "id": "53",
    "harborNameCn": "汕尾港",
    "harborNameEn": "SHANWEI ",
    "harborLongitude": 115.358,
    "harborLatitude": 22.76,
  }, {
    "id": "54",
    "harborNameCn": "大连港",
    "harborNameEn": "DALIAN ",
    "harborLongitude": 121.7645,
    "harborLatitude": 38.997475,
  }, {
    "id": "55",
    "harborNameCn": "石岛港",
    "harborNameEn": "SHIDAO ",
    "harborLongitude": 122.4488,
    "harborLatitude": 36.890725,
  }, {
    "id": "56",
    "harborNameCn": "唐山港",
    "harborNameEn": "TANGSHAN ",
    "harborLongitude": 119.01535,
    "harborLatitude": 39.200875,
  }, {
    "id": "57",
    "harborNameCn": "苏州港",
    "harborNameEn": "SUZHOU ",
    "harborLongitude": 120.633056,
    "harborLatitude": 31.3,
  }, {
    "id": "58",
    "harborNameCn": "桃园港",
    "harborNameEn": "TAOYUAN ",
    "harborLongitude": 121.2994,
    "harborLatitude": 24.9928,
  }, {
    "id": "59",
    "harborNameCn": "连云港",
    "harborNameEn": "LIANYUNGANG ",
    "harborLongitude": 119.56655,
    "harborLatitude": 34.79039,
  }, {
    "id": "60",
    "harborNameCn": "妈湾港",
    "harborNameEn": "MAWAN ",
    "harborLongitude": 113.8714,
    "harborLatitude": 22.4804,
  }, {
    "id": "61",
    "harborNameCn": "镇海港",
    "harborNameEn": "ZHENHAI ",
    "harborLongitude": 121.6897,
    "harborLatitude": 29.93838,
  }, {
    "id": "62",
    "harborNameCn": "北仑港",
    "harborNameEn": "BEILUN ",
    "harborLongitude": 121.8525,
    "harborLatitude": 29.926545,
  }, {
    "id": "63",
    "harborNameCn": "外高桥港",
    "harborNameEn": "WAIGAOQIAO ",
    "harborLongitude": 121.559,
    "harborLatitude": 31.333,
  }, {
    "id": "64",
    "harborNameCn": "东山港",
    "harborNameEn": "DONGSHAN ",
    "harborLongitude": 117.4789,
    "harborLatitude": 23.7451,
  }, {
    "id": "65",
    "harborNameCn": "古雷港",
    "harborNameEn": "GULEI ",
    "harborLongitude": 117.6045,
    "harborLatitude": 23.7662,
  }, {
    "id": "66",
    "harborNameCn": "海沧港",
    "harborNameEn": "HAICANG ",
    "harborLongitude": 117.9877,
    "harborLatitude": 24.4568,
  }, {
    "id": "67",
    "harborNameCn": "维多利亚港",
    "harborNameEn": "VICTORIA HARBOUR ",
    "harborLongitude": 114.1706,
    "harborLatitude": 22.2886,
  }, {
    "id": "68",
    "harborNameCn": "黄埔港",
    "harborNameEn": "Huangpu ",
    "harborLongitude": 113.5281,
    "harborLatitude": 23.05658,
  }, {
    "id": "69",
    "harborNameCn": "新会港",
    "harborNameEn": "XINHUI ",
    "harborLongitude": 113.0355,
    "harborLatitude": 22.4481,
  }, {
    "id": "70",
    "harborNameCn": "三埠港",
    "harborNameEn": "SANBU ",
    "harborLongitude": 112.7171,
    "harborLatitude": 22.369,
  }, {
    "id": "71",
    "harborNameCn": "南海港",
    "harborNameEn": "NANHAI ",
    "harborLongitude": 113.280201,
    "harborLatitude": 22.7395363,
  }, {
    "id": "72",
    "harborNameCn": "三水港",
    "harborNameEn": "Sanshui ",
    "harborLongitude": 112.85,
    "harborLatitude": 23.1666666666667,
  }, {
    "id": "73",
    "harborNameCn": "高明港",
    "harborNameEn": "Gaoming ",
    "harborLongitude": 112.898041,
    "harborLatitude": 22.88657285,
  }, {
    "id": "74",
    "harborNameCn": "莆田港",
    "harborNameEn": "PUTIAN ",
    "harborLongitude": 119.2986,
    "harborLatitude": 25.43106,
  }, {
    "id": "75",
    "harborNameCn": "广州港",
    "harborNameEn": "GUANGZHOU ",
    "harborLongitude": 113.425,
    "harborLatitude": 23.0855,
  }, {
    "id": "76",
    "harborNameCn": "秦皇岛港",
    "harborNameEn": "QINHUANGDAO ",
    "harborLongitude": 119.64495,
    "harborLatitude": 39.91558,
  }, {
    "id": "77",
    "harborNameCn": "钦州港",
    "harborNameEn": "QINZHOU ",
    "harborLongitude": 108.6215,
    "harborLatitude": 21.9628,
  }, {
    "id": "78",
    "harborNameCn": "三亚港",
    "harborNameEn": "SANYA ",
    "harborLongitude": 109.506,
    "harborLatitude": 18.226,
  }, {
    "id": "79",
    "harborNameCn": "太仓港",
    "harborNameEn": "TAICANG ",
    "harborLongitude": 121.1685,
    "harborLatitude": 31.659,
  }, {
    "id": "80",
    "harborNameCn": "常熟港",
    "harborNameEn": "CHANGSHU ",
    "harborLongitude": 120.9466,
    "harborLatitude": 31.7635,
  }, {
    "id": "81",
    "harborNameCn": "张家港",
    "harborNameEn": "ZHANGJIAGANG ",
    "harborLongitude": 120.4193,
    "harborLatitude": 31.97519,
  }, {
    "id": "82",
    "harborNameCn": "宜昌港",
    "harborNameEn": "YICHANG ",
    "harborLongitude": 111.3258,
    "harborLatitude": 30.7696,
  }, {
    "id": "83",
    "harborNameCn": "荆州港",
    "harborNameEn": "JINGZHOU ",
    "harborLongitude": 112.22455,
    "harborLatitude": 30.25829,
  }, {
    "id": "84",
    "harborNameCn": "武汉港",
    "harborNameEn": "WUHAN ",
    "harborLongitude": 114.31585,
    "harborLatitude": 30.59441,
  }, {
    "id": "85",
    "harborNameCn": "长沙市港",
    "harborNameEn": "CHANGSHA ",
    "harborLongitude": 112.9772,
    "harborLatitude": 28.1846,
  }, {
    "id": "86",
    "harborNameCn": "岳阳港",
    "harborNameEn": "YUEYANG ",
    "harborLongitude": 113.117,
    "harborLatitude": 29.357,
  }, {
    "id": "87",
    "harborNameCn": "九江港",
    "harborNameEn": "JIUJIANG ",
    "harborLongitude": 115.9971,
    "harborLatitude": 29.759295,
  }, {
    "id": "88",
    "harborNameCn": "泸州港",
    "harborNameEn": "LUZHOU ",
    "harborLongitude": 105.4296,
    "harborLatitude": 28.888265,
  }, {
    "id": "89",
    "harborNameCn": "重庆港",
    "harborNameEn": "CHONGQING ",
    "harborLongitude": 106.60535,
    "harborLatitude": 29.56956,
  }, {
    "id": "90",
    "harborNameCn": "安庆市港",
    "harborNameEn": "ANQING ",
    "harborLongitude": 117.0535,
    "harborLatitude": 30.511585,
  }, {
    "id": "91",
    "harborNameCn": "乍浦港",
    "harborNameEn": "ZHAPU ",
    "harborLongitude": 121.09545,
    "harborLatitude": 30.609,
  }, {
    "id": "92",
    "harborNameCn": "威海港",
    "harborNameEn": "WEIHAI ",
    "harborLongitude": 122.21395,
    "harborLatitude": 37.476,
  }, {
    "id": "93",
    "harborNameCn": "温州港",
    "harborNameEn": "WENZHOU ",
    "harborLongitude": 120.80195,
    "harborLatitude": 27.982865,
  }, {
    "id": "94",
    "harborNameCn": "香港",
    "harborNameEn": "HONG KONG ",
    "harborLongitude": 114.16815,
    "harborLatitude": 22.31081,
  }, {
    "id": "95",
    "harborNameCn": "阳江港",
    "harborNameEn": "YANGJIANG ",
    "harborLongitude": 111.80535,
    "harborLatitude": 21.66159,
  }, {
    "id": "96",
    "harborNameCn": "扬州港",
    "harborNameEn": "YANGZHOU ",
    "harborLongitude": 119.47255,
    "harborLatitude": 32.312645,
  }, {
    "id": "97",
    "harborNameCn": "烟台港",
    "harborNameEn": "YANTAI ",
    "harborLongitude": 121.4097,
    "harborLatitude": 37.56646,
  }, {
    "id": "98",
    "harborNameCn": "营口港",
    "harborNameEn": "YINGKOU ",
    "harborLongitude": 122.26615,
    "harborLatitude": 40.693625,
  }, {
    "id": "99",
    "harborNameCn": "漳州港",
    "harborNameEn": "ZHANGZHOU ",
    "harborLongitude": 118.0476,
    "harborLatitude": 24.41093,
  }, {
    "id": "100",
    "harborNameCn": "湛江港",
    "harborNameEn": "ZHANJIANG ",
    "harborLongitude": 110.46575,
    "harborLatitude": 21.186145,
  }, {
    "id": "101",
    "harborNameCn": "镇江港",
    "harborNameEn": "ZHENJIANG ",
    "harborLongitude": 119.38875,
    "harborLatitude": 32.20829,
  }, {
    "id": "102",
    "harborNameCn": "芜湖港",
    "harborNameEn": "WUHU ",
    "harborLongitude": 118.33715,
    "harborLatitude": 31.367085,
  }, {
    "id": "103",
    "harborNameCn": "中山港",
    "harborNameEn": "ZHONGSHAN ",
    "harborLongitude": 113.48445,
    "harborLatitude": 22.58245,
  }, {
    "id": "104",
    "harborNameCn": "舟山港",
    "harborNameEn": "ZHOUSHAN ",
    "harborLongitude": 122.21035,
    "harborLatitude": 29.92161,
  }, {
    "id": "105",
    "harborNameCn": "铜陵港",
    "harborNameEn": "TONGLING ",
    "harborLongitude": 117.7607,
    "harborLatitude": 30.91488,
  }, {
    "id": "106",
    "harborNameCn": "南京港",
    "harborNameEn": "NANJING ",
    "harborLongitude": 118.812,
    "harborLatitude": 32.2125,
  }, {
    "id": "107",
    "harborNameCn": "珠海市港",
    "harborNameEn": "ZHUHAI ",
    "harborLongitude": 113.2,
    "harborLatitude": 21.91982,
  }, {
    "id": "1",
    "harborNameCn": "中山国际港",
    "harborNameEn": "Zhongshan INTL ",
    "harborLongitude": 113.4741,
    "harborLatitude": 22.5729,
  }], "msg"
:
  "执行成功"
}
